import { render, staticRenderFns } from "./detail-follow.vue?vue&type=template&id=4f43bec7&scoped=true"
import script from "./detail-follow.vue?vue&type=script&lang=js"
export * from "./detail-follow.vue?vue&type=script&lang=js"
import style0 from "./detail-follow.vue?vue&type=style&index=0&id=4f43bec7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f43bec7",
  null
  
)

export default component.exports